jQuery(document).ready(
    function ($) {
        $("body").on('click touch', '.hamburger', function (e) {
            e.preventDefault();
            $("body").removeClass("show-search");
            $("body").toggleClass("show-menu");
            $(this).toggleClass("is-active");

            if ($(this).hasClass("is-active")) {
                $(this).attr("aria-expanded", "true");
            } else {
                $(this).attr("aria-expanded", "false");
            }
        });
    }
);
